<template>
  <!-- KS_JP唛头 -->
  <div style="page-break-after:always;">
    <div class="main" v-for="(datas, index) in printData" :key="index">
      <div class="content">
        <div class="head">
          <div class="logo">
            <img src="../../assets/img/user-img/qs.png" alt="">
            <div class="name">

              {{ datas.logistics == 'KS-JP航空便' ? 'KS-JP' : datas.logistics }}
            </div>
          </div>
          <div class="head-porder">
            <!-- <img src="../../assets/img/user-img/qs.png" alt=""> -->

            <div>
              <!-- FBA授权 -->
              <div v-if="datas.porder.is_fba" style="font-size: 35px; ">
                {{ datas.porder.importer.company }}
              </div>
              <div class="porder">
                {{ datas.porder_sn.split('-')[0].substr(datas.porder_sn.split('-')[0].length
                  - 4, datas.porder_sn.split('-')[0].length) + '-' + datas.porder_sn.split('-')[1] }}-{{
                  datas.number }}
              </div>
            </div>

          </div>
          <!-- 授权 -->
          <!-- <p v-if="datas.order_box" style="font-size: 70px; margin: 100px 0;">
            {{
              `${datas.express_no}-${datas.number_by_express_no}共（${datas.count_by_express_no}）箱` }}
          </p> -->
          <!-- 不授权 -->
          <div>
            <div class="barcode">
              <!-- 一维码 -->
              <canvas :id="'express_no' + index" />
            </div>
            <p> {{ datas.express_no }}-{{ datas.number_by_express_no }}</p>
          </div>
        </div>
        <div class="boxNum">
          <!-- 授权 -->
          <div>
            {{ `${datas.express_no}` }}-<span class="number_by_express_no">{{ datas.number_by_express_no }}</span>
          </div>
          <span class="count_by_express_no">共（{{ datas.count_by_express_no }}）箱</span>
        </div>
        <!-- 收件 -->
        <div class="addressee">
          <div class="left">
            <div class="img">
              <img src="../../assets/img/user-img/hezuo.png" alt="">
            </div>
            <div>
              <p>收件人</p>
              <h6>{{ datas.porder.receiver.contacts }}（{{
                datas.porder.receiver.mobile ? datas.porder.receiver.mobile : datas.porder.receiver.tel }}）</h6>
            </div>
          </div>
          <!-- <div class="right">
            KS-JP
          </div> -->
        </div>
        <!-- 进口 -->

        <div class="order">
          <div class="left">
            <p v-if="datas.order_box" style="font-size: 38px;"> {{ `${datas.order_box.order_sn}-
              ${datas.order_box.box_no}`
              }}</p>
            <!-- <p style="margin-bottom: 20px;; font-size: 43px;">{{ datas.porder_sn }}</p> -->
            <div class="barcode">
              <!-- 一维码 -->
              <canvas :id="'expressNo' + index" />
            </div>
            <p>{{ datas.express_no }}
            </p>
          </div>
          <div class="right">
            <div class="item">
              <p>配货：{{ datas.p_name }}
              </p>
              <p class="fontWeight">Weight：{{ datas.weight }}</p>
              <p class="fontWeight">Size：{{ datas.length }}*{{ datas.width }}*{{ datas.height }}
              </p>

            </div>
            <div class="item">
              <p>Print date</p>
              <p>{{ getDate() }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDate } from '@/utlis/date'
import { mapState } from 'vuex';
export default {
  props: {
    datas: { type: Object },
    logistics: { type: String }
  },
  data() {
    return {
      getDate
    };
  },
  computed: {
    ...mapState(
      {
        printData: (state) => state.porderDetail.printData, //要打印的数据
        p_name: (state) => state.porderDetail.detail.p_name, //全部详情
      }
    )

  },

  mounted() {
    this.$nextTick(() => {
      this.printData.forEach((item, index) => {
        this.getJsBarcode("#express_no" + index, item.express_no + '-' + item.number_by_express_no, index);
        this.getJsBarcode("#expressNo" + index, item.express_no);
      })

    })
  },
  methods: {

    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 180,
        width: data.length > 8 ? 6 : 10,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();

    },
    // 一维码
    getJsBarcode1(selector, data, index) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 180,
        width: data.length > 8 ? 6 : 10,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.printData[index].show = true

      this.$forceUpdate();
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1080px;
  height: 1672px;
  background: #fff;
  padding: 50px;
  color: #000000 !important;
  font-weight: 600 !important;


  .content {
    width: 1064px;
    height: 1655px;
    background: #FFFFFF;
    border: 4px solid #000000;

    .head {
      padding: 20px 40px 30px;

      .logo {
        font-size: 66px;
        display: flex;
        justify-content: space-between;

        img {
          width: 220px;
        }

        .name {
          line-height: 100px;
        }
      }

      .head-porder {

        margin-top: 10px;
        text-align: center;

        .porder {
          flex: 1;
          font-size: 120px;
          line-height: 110px;
          font-weight: 600;
          text-align: center;
          // background-color: #000;
          // color: #fff;
        }


      }

      .barcode {
        width: 100%;
        height: 240px;
        overflow: hidden;
        margin: 34px 0 26px;
      }

      #inspect_sn {
        width: 100%;
        height: 240px;
        overflow: hidden;

        /deep/.isNeedRemove {
          width: 100%;
          height: 240px !important;

        }
      }

      p {
        text-align: center;
        font-size: 40px;
        margin-bottom: 20px;
      }


    }

    .boxNum {
      font-size: 84px;
      text-align: center;
      height: 200px;
      line-height: 200px;
      border-top: 4px solid #000;
      border-bottom: 4px solid #000;
      position: relative;
      padding: 0 50px;
      display: flex;
      justify-content: space-between;

      .count_by_express_no {
        font-size: 60px;

      }

      .number_by_express_no {
        font-size: 120px;
      }
    }

    .addressee {
      height: 242px;
      border-bottom: 4px solid #000;
      display: flex;
      padding: 20px 0;

      p {
        font-size: 40px;
      }

      h6 {
        font-size: 50px;
        font-weight: 600;
        // word-break: break-all;

      }

      .left {
        .img {
          display: flex;
          align-items: center;

          img {
            width: 80px;
            margin-right: 40px;
            line-height: 262px;
          }
        }

        display: flex;
        padding: 30px 40px;
      }


    }

    .entrance {
      font-size: 50px;
      padding: 30px 40px;
      border-bottom: 4px solid #000;

      p {
        font-size: 40px;


      }
    }

    .order {

      height: 447px;
      display: flex;

      .left {
        padding: 40px;
        width: 560px;
        font-size: 50px;
        border-right: 4px solid #000;

        .barcode {
          width: 560px;
          height: 180px;
          overflow: hidden;
          margin: 40px 0 30px;

          img {
            width: 100%;
          }
        }

        p {
          font-size: 40px;
          text-align: center;
        }
      }

      .right {
        flex: 1;

        .item {
          padding: 40px 40px;

          &:nth-child(1) {
            border-bottom: 4px solid #000;
          }

          p {
            font-size: 30px;
          }

          .fontWeight {
            font-weight: 600;
            font-size: 46px;
          }
        }
      }
    }
  }
}
</style>
